import React, { useEffect, useState } from 'react';
import { X, Cookie } from 'lucide-react';

const KEY = 'ek-cookie-consent-v1';

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) {
        const t = window.setTimeout(() => setOpen(true), 600);
        return () => window.clearTimeout(t);
      }
    } catch {
      /* storage disabled — skip */
    }
  }, []);

  const dismiss = () => {
    setOpen(false);
    try {
      localStorage.setItem(KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() }));
    } catch {
      /* ignore */
    }
  };

  if (!open) return null;

  return (
    <div
      className={`ek-cookie ${open ? 'is-open' : ''}`}
      role="dialog"
      aria-live="polite"
      aria-label="Cookie notice"
      data-testid="cookie-banner"
    >
      <span className="ek-cookie-icon" aria-hidden="true">
        <Cookie size={16} />
      </span>
      <p className="ek-cookie-text">
        <strong>Just so you know:</strong> this site uses a single session cookie — only after you sign in to the admin panel.
        No tracking cookies, no ads.{' '}
        <a href="/legal/privacy" className="ek-cookie-link" data-testid="cookie-banner-privacy-link">
          Read the privacy policy
        </a>
        .
      </p>
      <div className="ek-cookie-actions">
        <button
          type="button"
          onClick={dismiss}
          className="ek-cookie-ok"
          data-testid="cookie-banner-accept"
        >
          Got it
        </button>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss notice"
          className="ek-cookie-close"
          data-testid="cookie-banner-close"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
